import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSiteMode } from '../../contexts/SiteModeContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TestingBanner = () => {
  const { refresh } = useSiteMode();
  const navigate = useNavigate();

  const signOut = async () => {
    try { await axios.post(`${API}/tester/logout`, {}, { withCredentials: true }); } catch { /* cookie cleared server-side */ }
    await refresh();
    navigate('/', { replace: true });
  };

  return (
    <div className="fm-testing-banner" data-testid="testing-banner">
      <span>Testing mode. Public visitors see the Founding Member page.</span>
      <button type="button" onClick={signOut} data-testid="testing-banner-signout">Sign out</button>
    </div>
  );
};
